import { DESKTOP } from "../../../constants/breakpoints";
import React from "react";

export const WidgetsContext = React.createContext({
  selector: null,
  breakpoint: DESKTOP,
  shouldZoom: true,
  domain: null,
  development: false,
  carouselSlide: null,
  createLiveElementContext: (id) => { },
  createGatingContext: (id) => { },
  fetchGating: (id) => { },
  onTriggerMixpanelEvent: (session, eventName, properties) => { },
  updateCarouselSlide: (payload) => {},
});

export const FormContext = React.createContext({
  useForm: () => { },
  useFormValue: ['', () => { }],
  submitForm: () => { },
  formSuccess: false
})

export const SeekContext = React.createContext({
  disabled: true,
  seekSession: null,
  seekAnswerForQuestion: (widget, id, question, pageSession, storyboard) => { },
  updateSeekHelpful: (widget, chatId, helpful) => { },
  invalidateSeekSession: (widget, seekSessionId) => { },
  seekChatHistory: (session, widget, question, callback ) => {}
});

export const GatingContext = React.createContext({
  triggerGating: () => { },
  type: null,
  payload: null,
  gating: null,
  configuration: null,
  configurations: [],
  assetConfigurations: []
});

export const ModalContext = React.createContext({
  close: () => { }
})

export const EmbedContext = React.createContext({
  embedded: false
})

export const ImageKitContext = React.createContext("")